const LOGIN_LOCK_PREFIX = 'point_login_lock_';
const LOGIN_LOCK_MS = 60 * 1000;

export function getLoginLockUntil(failedAttempts, now = Date.now()) {
  if (!Number.isFinite(Number(failedAttempts)) || Number(failedAttempts) < 3) {
    return null;
  }
  return Number(now) + LOGIN_LOCK_MS;
}

export function isLoginLocked(lockUntil, now = Date.now()) {
  const until = Number(lockUntil || 0);
  return Number.isFinite(until) && until > 0 && until > Number(now);
}

export function getRemainingLockMs(lockUntil, now = Date.now()) {
  const until = Number(lockUntil || 0);
  if (!Number.isFinite(until) || until <= 0) return 0;
  const remaining = until - Number(now);
  return remaining > 0 ? remaining : 0;
}

export function readLoginLockState(username) {
  const key = `${LOGIN_LOCK_PREFIX}${String(username || '').trim().toLowerCase()}`;
  if (!key || key === LOGIN_LOCK_PREFIX) return null;

  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      count: Number(parsed.count || 0),
      lockUntil: Number(parsed.lockUntil || 0),
      lastFailedAt: Number(parsed.lastFailedAt || 0),
    };
  } catch (_) {
    return null;
  }
}

export function writeLoginLockState(username, state) {
  const key = `${LOGIN_LOCK_PREFIX}${String(username || '').trim().toLowerCase()}`;
  if (!key || key === LOGIN_LOCK_PREFIX) return;

  try {
    localStorage.setItem(key, JSON.stringify({
      count: Number(state?.count || 0),
      lockUntil: Number(state?.lockUntil || 0),
      lastFailedAt: Number(state?.lastFailedAt || Date.now()),
    }));
  } catch (_) {
    // no-op for storage issues
  }
}

export function recordLoginFailure(username) {
  const safeUser = String(username || '').trim();
  if (!safeUser) return { count: 0, lockUntil: 0, lastFailedAt: Date.now() };

  const previous = readLoginLockState(safeUser) || { count: 0, lockUntil: 0, lastFailedAt: 0 };
  const nextCount = Number(previous.count || 0) + 1;
  const nextState = {
    count: nextCount,
    lockUntil: getLoginLockUntil(nextCount, Date.now()),
    lastFailedAt: Date.now(),
  };

  writeLoginLockState(safeUser, nextState);
  return nextState;
}

export function clearLoginLockState(username) {
  const key = `${LOGIN_LOCK_PREFIX}${String(username || '').trim().toLowerCase()}`;
  if (!key || key === LOGIN_LOCK_PREFIX) return;

  try {
    localStorage.removeItem(key);
  } catch (_) {
    // no-op
  }
}
